import { render, staticRenderFns } from "./Marriage.vue?vue&type=template&id=77f94d32&scoped=true&"
import script from "./Marriage.vue?vue&type=script&lang=js&"
export * from "./Marriage.vue?vue&type=script&lang=js&"
import style0 from "./Marriage.vue?vue&type=style&index=0&id=77f94d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f94d32",
  null
  
)

export default component.exports